import React, { useContext } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { AuthContext } from "./store/auth-context";
import About from "./Pages/About";
import AllMeetupsPage from "./Pages/AllMeetups";
import FavoritesPage from "./Pages/Favorites";
import NewMeetup from "./Pages/NewMeetup";

import LoginPage from "./login/Login";
import SignupPage from "./login/Signup";
import MainNavigation from "./components/layout/MainNavigation";
import { FavoritesContextProvider } from "./store/favorites-context";
import AppLoader from "./components/layout/ui/Apploader";

function RouteProvider() {
    const { checked, user } = useContext(AuthContext);

    /*
	If we haven't checked the authentication yet, we just want to show them
	a loading screen of some sort.
	*/

    if (!checked) {
        return <AppLoader color={"#007FFF"} loading={true} size={50} />;
    }

    return (
		<BrowserRouter>
			{/* If User is authenticated, allow them to acces authenticated
            routes... //Add other authenticated routes here. Last route should
            redirect to a 404 or home.*/}
			{checked && user && (
				<FavoritesContextProvider>
					<div>
						<MainNavigation />
						<Routes>
							<Route
								path="/"
								index
								element={<AllMeetupsPage />}
							/>
							<Route
								path="/all-meetups"
								element={<AllMeetupsPage />}
							/>
							<Route path="/new-meetup" element={<NewMeetup />} />
							<Route
								path="/favorites"
								element={<FavoritesPage />}
							/>
							<Route path="/about" element={<About />} />
							<Route
								path="*"
								element={<Navigate to="/" replace />}
							/>
						</Routes>
					</div>
				</FavoritesContextProvider>
			)}
			{checked && !user &&  (
				<>
					<MainNavigation />
					<Routes>
						{/*
                        If user is not authenticated
						Add unauthenticated routes here. Signup, forgotten password etc.
						We add the Login component as the last route with no path so
						that it can act as a fallback. This way, if someone tries to 
						access any authenticated route they'll get the login page on 
						that url and, once they log in, they'll automatically be on the 
						correct page.
					*/}

						<Route path="/" index element={<AllMeetupsPage />} />
						<Route
							path="/all-meetups"
							element={<AllMeetupsPage />}
						/>
						<Route path="/about" element={<About />} />
						<Route path="/favorites" element={<FavoritesPage />} />
						<Route path="/login" element={<LoginPage />} />
						<Route path="/signup" element={<SignupPage />} />
						<Route
							path="*"
							element={<Navigate to="/login" replace />}
						/>
					</Routes>
				</>
			)}
		</BrowserRouter>
	);
}

export default RouteProvider;
